import { create } from 'zustand';
import { FileUtils } from '@shared/utils';
import { AccountApi, ApiUtils, type GetCreditPdfRequest, RequestStrategyEnum } from '@shared/api';

interface UseCreditPdfStore {
  loading: boolean;
  data: Blob | null;
  error: string | null;
  getCreditPdf: (request: { data: GetCreditPdfRequest; filename?: string }, isPreview?: boolean, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCreditPdfStore = create<UseCreditPdfStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  getCreditPdf: ApiUtils.wrapperApi(async (request, isPreview, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountApi.getCreditPdf(request.data, signal);
      console.log('getCreditPdf', result);
      !isPreview && FileUtils.downloadFile(result, request.filename);
      set({ loading: false, data: isPreview ? result || null : null });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: null, error: null }),
}));
